import { dispatchGetRequest } from '../util/apiUtils.ts';

const profileBaseUrl = process.env.PROFILE_BASE_URL;
// TODO: find a way to extract this value from tenantConfig
const accountId = 'ozoDdrmewShEcbUDWX8J3V';

export const getProfile = async () => {
  const url = `${profileBaseUrl}/v1/${accountId}/profile/me`;
  try {
    const response = await dispatchGetRequest({ url });
    const data = await response.json();
    return data;
  } catch (err) {
    // Catch the error and do nothing.
    // this was done to keep in parity with pre 'dispatchGetRequest' implementation.
    // if needed -> come back and handle error
  }
};
